import { useEffect, RefObject } from "react";
import { ChatMessage } from "../types/chat";
import { useIsTyping } from "../utils/typingGate";

export const useAutoScroll = (
  containerRef: RefObject<HTMLDivElement>,
  messages: ChatMessage[]
) => {
  const isTyping = useIsTyping();

  useEffect(() => {
    if (containerRef.current) {
      const container = containerRef.current;
      const scrollToBottom = () => {
        container.scrollTo({
          top: container.scrollHeight,
          behavior: "smooth",
        });
      };

      // Use requestAnimationFrame to ensure DOM is updated
      requestAnimationFrame(scrollToBottom);
    }
  }, [messages, isTyping, containerRef]);
};
